import React from "react"
import { Heading4 } from "./typography/headings"
import { BodyTextRegular } from "./typography/text"
import { ButtonAction } from "./button/ButtonAction"
import { useErrorBoundary } from "react-error-boundary"

export const ErrorFallbackUI = () => {
  const Logo = process.env.GATSBY_LOGO || ""
  const { resetBoundary } = useErrorBoundary()

  return (
    <div className="flex flex-col items-center justify-center w-screen h-screen bg-backgroundBranded gap-2">
      <img className="h-12" src={Logo} />
      <Heading4 className="text-foreground-base">Something went wrong</Heading4>
      <BodyTextRegular className="text-foreground-subtle">
        An unknown error occurred
      </BodyTextRegular>
      <ButtonAction
        className="w-full max-w-[250px] mt-4"
        onClick={() => {
          resetBoundary()
        }}
        size="large"
      >
        Try again
      </ButtonAction>
    </div>
  )
}
